var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 394,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57 -1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5 1368.33C59.5 1332.53 88.5274 1303.5 124.335 1303.5L383.665 1303.5C419.473 1303.5 448.5 1332.53 448.5 1368.33L448.5 1627.67C448.5 1663.47 419.473 1692.5 383.665 1692.5L124.335 1692.5C88.5274 1692.5 59.5 1663.47 59.5 1627.67Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#9142FF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5 1398.33C104.5 1370.81 126.812 1348.5 154.334 1348.5L353.666 1348.5C381.188 1348.5 403.5 1370.81 403.5 1398.33L403.5 1597.67C403.5 1625.19 381.188 1647.5 353.666 1647.5L154.334 1647.5C126.812 1647.5 104.5 1625.19 104.5 1597.67Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.436 1497.58 287.304 1405.71 305.516 1423.93 213.647 1515.79Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.304 1589.45 195.576 1497.72 213.815 1479.48 305.543 1571.21Z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPrev);
export default __webpack_public_path__ + "static/media/button_prev.fbafeb4b580525b3569cb10fb24a1264.svg";
export { ForwardRef as ReactComponent };